import * as sagas from '../helpers/sagas';
import { types } from '../actions/analytics';
import { api } from '../resources/analytics';

const redirectToSeatics = (props) => {
  //window.Seatics.Presentation.redirectToCheckout(props.ticket, props.quantity);

  return {
    type: 'SEATICS_CHECKOUT',
    payload: props,
  };
};

const takeEvery = [
  {
    type: types.ANALYTICS_VIEW_TICKET,
    call: api.viewTicket,
  },
  {
    type: types.ANALYTICS_BUY_TICKET,
    call: api.buyTicket,
    onSuccess: (props) => redirectToSeatics(props),
    onFailure: (e, props) => redirectToSeatics(props),
  },
  {
    type: types.ANALYTICS_NEW_SESSION,
    call: api.newSession,
  },
  {
    type: types.ANALYTICS_ACTION,
    call: api.recordAction,
  },
];

const analytics = takeEvery.map(sagas.makeTakeEvery);

export default analytics;



// WEBPACK FOOTER //
// ./src/sagas/analytics.js